<template>
    <v-dialog
        v-model="scoreDetailDialog.dialog"
        :max-width="options.width"
        v-bind:style="{ zIndex: options.zIndex }"
        content-class="">
        <v-form ref="forms">
            <v-card class="dialog-card">
                <v-card-title class="title blue-title pa-3 pt-4 ml-2">
                    Scoring Content（Class ID：{{scoreDetailDialog.clid}}）
                    <div class="header-close" title="close" @click="scoreDetailDialog.dialog=false"><v-icon>close</v-icon></div>
                </v-card-title>
                <v-card-text>   
                    <v-layout wrap px-2>
                        <v-flex xs12>
                            <div>Total Score：<span :class="scoreDetailDialog.contents.FollowStatus == 1 ?'text-green':'text-red'">{{scoreDetailDialog.contents.FollowScore}}【{{ scoreDetailDialog.contents.FollowStatus == 1 ?'Qualified': 'Unqualified' }}】</span></div>
                            <div style="display: flex; margin-top: 10px;">
                                <div style="width: 160px;">Details of Scoring：</div>
                                <div>
                                    <div>1、TPR   Usage(10): <span style="font-weight: bold;">{{ scoreDetailDialog.contents.TPRScore }}</span></div>
                                    <div>
                                        {{ scoreDetailDialog.contents.TPRScoreRemark }}
                                    </div>
                                    <br/>
                                    <div>2、Incentive Mechanism (10): <span style="font-weight: bold;">{{ scoreDetailDialog.contents.RewardScore }}</span></div>
                                    <div>
                                        {{ scoreDetailDialog.contents.RewardScoreRemark }}
                                    </div>
                                    <br/>
                                    <!-- IncentiveMechanism: t.RewardScore,
                                    StudentOutput: t.StuOutputScore,
                                    Handling: t.ResolvingScore,
                                    UseOf: t.UseToolScore,
                                    TeachingAttitude: t.AttitudeScore,
                                    TeachingEnvironment: t.EnvironmentScore,
                                    IceBreaking: t.IcebreakingScore,
                                    Correction: t.CorrectionScore,
                                    Accent: t.SoundScore, -->
                                    <div>3、Student  Output (10): <span style="font-weight: bold;">{{ scoreDetailDialog.contents.StuOutputScore }}</span></div>
                                    <div>
                                        {{ scoreDetailDialog.contents.StuOutputScoreRemark }}
                                    </div>

                                    <br/>
                                    <div>4、 Handling of Student Difficulties(10):<span style="font-weight: bold;">{{ scoreDetailDialog.contents.ResolvingScore }}</span></div>
                                    <div>
                                        {{ scoreDetailDialog.contents.ResolvingScoreRemark }}
                                    </div>
                                    <br/>
                                    <div>5、Use of Teaching Aids(10): <span style="font-weight: bold;">{{ scoreDetailDialog.contents.UseToolScore }}</span></div>
                                    <div>
                                        {{ scoreDetailDialog.contents.UseToolScoreRemark }}
                                    </div>
                                    <br/>

                                    <div>6、Teaching Attitude(10):<span style="font-weight: bold;">{{ scoreDetailDialog.contents.AttitudeScore }}</span></div>
                                    <div>
                                        {{ scoreDetailDialog.contents.AttitudeScoreRemark }}
                                    </div>
                                    <br/>

                                    <div>7、Teaching Environment(10):<span style="font-weight: bold;">{{ scoreDetailDialog.contents.EnvironmentScore }}</span></div>
                                    <div>
                                        {{ scoreDetailDialog.contents.EnvironmentScoreRemark }}
                                    </div>
                                    <br/>

                                    <div>8、Ice-breaking Performance(10):<span style="font-weight: bold;">{{ scoreDetailDialog.contents.IcebreakingScore }}</span></div>
                                    <div>
                                        {{ scoreDetailDialog.contents.IcebreakingScoreRemark }}
                                    </div>
                                    <br/>

                                    <div>9、Correction(10):<span style="font-weight: bold;">{{ scoreDetailDialog.contents.CorrectionScore }}</span></div>
                                    <div>
                                        {{ scoreDetailDialog.contents.CorrectionScoreRemark }}
                                    </div>
                                    <br/>

                                    <div>10、 Accent(10):<span style="font-weight: bold;">{{ scoreDetailDialog.contents.SoundScore }}</span></div>
                                    <div>
                                        {{ scoreDetailDialog.contents.SoundScoreRemark }}

                                    </div>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-text>

            </v-card>
        </v-form>
    </v-dialog>
</template>
<script>

export default {
    data:()=>({
        options:{
            width: 700,
            zIndex: 200
        },
        
    }),
    props: {
        scoreDetailDialog: {
            dialog: false,
            clid: 0,
            title:'',
            contents:''
        }
    },
    mounted(){
    },
    methods:{
     
    },
    watch:{
        'scoreDetailDialog.dialog': function (value, oldValue) {
            
            if (value !== oldValue) {
   
            }
        }
    }
}
</script>
<style scoped>
.text-green{
    color: green;
}
.text-red{
    color: red;
}
</style>